import { render } from "./Emoji.vue?vue&type=template&id=21cb4de0&scoped=true"
import script from "./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue?vue&type=script&lang=js"

import "./Emoji.vue?vue&type=style&index=0&id=21cb4de0&lang=scss&scoped=true"
import "./Emoji.vue?vue&type=style&index=1&id=21cb4de0&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cb4de0"]])

export default __exports__